import React, { Fragment, useState, useEffect } from "react";
import styles from './filter.module.css'

const Filter = ({ cars, operKind, sendDataToParent, formCall='operdone' }) => {
  // آرایه‌هایی که باید تغییرات چک‌باکس‌ها ذخیره بشن
  const [carFalseArray, setCarFalseArray] = useState([]);
  const [serviceTypeArray, setServiceTypeArray] = useState([]);

  // مقدار نوع سرویس انتخاب شده
  const [operKindId, setOperkindId] = useState('0');
  // مقدار توضیحات
  const [desc, setDesc] = useState('');

  // مقداردهی اولیه چک‌باکس‌ها (هر کدوم true هستند پس این آرایه‌ها خالی خواهند بود)
  // چون وقتی چک‌باکس تیک خورده باشه، نباید توی آرایه‌های false ذخیره بشه

  // هندلر تغییر وضعیت چک‌باکس خودروها
  const handleChange = (e) => {
    const id = e.target.id;
    if (!e.target.checked) {
      setCarFalseArray(prev => [...prev, id]);
    } else {
      setCarFalseArray(prev => prev.filter(item => item !== id));
    }
  };

  // هندلر تغییر وضعیت چک‌باکس نوع سرویس‌ها
  const changeServiceTypeHandle = (e) => {
    const id = e.target.id;
    if (!e.target.checked) {
      setServiceTypeArray(prev => [...prev, id]);
    } else {
      setServiceTypeArray(prev => prev.filter(item => item !== id));
    }
  };

  // هندلر تغییر انتخاب نوع سرویس از سلکت‌باکس
  const changeHandlerOperKind = (e) => {
    setOperkindId(e.target.value);
  };

  // هندلر تغییر مقدار توضیحات
  const descValueHandler = (e) => {
    setDesc(e.target.value);
  };

  // وقتی دکمه تایید زده میشه، داده‌ها رو به والد ارسال می‌کنیم
  const handleClick = () => {
    const sendData = {
      carId: carFalseArray,
      serviceType: serviceTypeArray,
      ok_Id: operKindId,
      desc: desc
    };
    sendDataToParent(sendData);
  };

  // وقتی دکمه لغو زده میشه، همه مقادیر رو ریست می‌کنیم و والد رو هم با مقادیر خالی صدا میزنیم
  const handleClose = () => {
    setCarFalseArray([]);
    setServiceTypeArray([]);
    setOperkindId('0');
    setDesc('');
    sendDataToParent([], [], '0', '');
  };

  return (
    <Fragment>
    {/* محتوای اصلی با اسکرول */}
    <div 
      className="container" 
      style={{ 
        maxHeight: '300px', 
        overflowY: 'auto',
        paddingBottom: '40px'
      }}
    >
      <div className="row row-cols-2">
        <div className="col">
          <span>نوع سرویس ها</span>
          <hr/>
          <div className={`${"form-check"} ${"form-switch"} ${styles["checkbox-lg"]}`}>
            <input
              className="form-check-input"
              type="checkbox"
              id='time'
              checked={!serviceTypeArray.includes('time')}
              onChange={changeServiceTypeHandle}
            />
            <label className="form-check-label" htmlFor="time">تقویمی</label>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id='km'
              checked={!serviceTypeArray.includes('km')}
              onChange={changeServiceTypeHandle}
            />
            <label className="form-check-label" htmlFor="km">کارکردی</label>
          </div>
        </div>
        <div className="col">
          <span>خودرو ها</span>
          <hr/>
          <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
            {cars.map((res) => (
              <div className={`${"form-check"} ${styles["checkbox-lg"]}`} key={res.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={res.id}
                  checked={!carFalseArray.includes(res.id)}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor={res.id}>
                  {res.title}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row row-cols-2 mt-3">
        <div className="col">
          <span> انتخاب سرویس</span>
          <hr/>
          <select
            className="form-select"
            id="operKind"
            name="operKind"
            onChange={changeHandlerOperKind}
            value={operKindId}
          >
            <option value="0">یک مورد را انتخاب نمایید</option>
            {operKind.map((res) => (
              <option key={res.ok_id} value={res.ok_id}>
                {res.ok_title}
              </option>
            ))}
          </select>
        </div>
          {formCall === "operdone" && (
            <div className="col">
              <span>توضیحات</span>
              <hr/>
              <div className="input-group mb-3">
                <input
                  type="text"
                  onChange={descValueHandler}
                  value={desc}
                  className="form-control"
                  placeholder="بخشی از توضیحات"
                />
              </div>
            </div>
          )}
      </div>
    </div>

    {/* دکمه‌های ثابت در پایین */}
    <div 
      className="container px-4" 
      style={{ 
        position: 'sticky', 
        bottom: 0, 
        backgroundColor: 'white', 
        padding: '10px 0',
        borderTop: '1px solid #dee2e6'
      }}
    >
      <div className="row gx-5">
        <div className="col">
          <button
            onClick={handleClick}
            className="btn btn-outline-success w-100"
            type="button"
          >
            تایید
          </button>
        </div>
        <div className="col">
          <button
            onClick={handleClose}
            className="btn btn-outline-danger w-100"
            type="button"
          >
            لغو
          </button>
        </div>
      </div>
    </div>
  </Fragment>
  );
};

export default Filter;
